import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Vehicle } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  vehicle: Vehicle
  overrideOwnership: Callback
}

export default class VehicleDetailsOwner extends Component<Props> {
  static displayName = 'VehicleDetailsOwner'

  render() {
    const {
      vehicle: { latestOwnershipVerification },
      overrideOwnership,
    } = this.props

    return (
      <div className="vehicle-details-owner">
        <div className="vehicle-details-owner__header">
          {latestOwnershipVerification ? (
            <div>
              Owner{' '}
              <Link
                to={`/users/${latestOwnershipVerification.user.id}`}
              >{`${latestOwnershipVerification.user.firstName} ${latestOwnershipVerification.user.lastName}`}</Link>
            </div>
          ) : (
            <div>No Owner</div>
          )}
        </div>
        <div className="vehicle-details-owner__verification">
          <span>Ownership</span>{' '}
          <a href="">
            {latestOwnershipVerification && latestOwnershipVerification.status}
          </a>
        </div>
        <div className="vehicle-details-owner__manual-override">
          <a role="button" onClick={overrideOwnership}>
            Manual Override
          </a>
        </div>
      </div>
    )
  }
}
